import React from "react";
import PropTypes from "prop-types";
import hotkeys from "helper/hotkey";
import Helper from "helper";
/**
 *
 * @param {Array} [keys=[]]
 * @returns {string} string representation of an array of keys
 */
const formatKeysForInput = (keys = []) => keys.join("+");

/**
 * @param {string} sequence keys sequence from MouseTrap Record -> "shift+left"
 * @returns {Array} keys in array-format -> ['shift','left']
 */
const getKeys = ({ sequence, modifier_keys }) => {
  const keysArray = sequence.join(" ").split("+");
  let keys = [];
  let modifiers = [];
  keysArray.forEach((key) => {
    if (modifier_keys && modifier_keys.includes(key)) {
      modifiers.push(key);
    } else {
      keys.push(key);
    }
  });
  return [...modifiers, ...keys];
};

const propTypes = {
  keys: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired,
  classNames: PropTypes.string,
  modifier_keys: PropTypes.array,
  allowed_keys: PropTypes.array,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
};
/**
 * HotkeyField
 * Renders a hotkey input
 *
 * @param {object} props                  ������Ƽ Object
 * @param {Array[]} props.keys            �Էµ� Ű �迭
 * @param {function} props.handleChange   Ű ����� ȣ��Ǵ� �̺�Ʈ �ڵ鷯
 * @param {string} props.classNames       input field�� ���� �Ǵ� CSS Ŭ����
 * @param {Array[]} props.modifier_keys
 */
function HotkeyField({
  keys,
  handleChange,
  classNames,
  modifier_keys,
  onFocus,
  onBlur,
}) {
  const inputValue = formatKeysForInput(keys);

  const InputKeyDownHandler = (event) => {
    event.stopPropagation();
    event.preventDefault();

    hotkeys.record((sequence) => {
      const keys = getKeys({ sequence, modifier_keys });
      hotkeys.unpause();
      handleChange(keys);
      hotkeys.startRecording();
    });
  };

  const focusHandler = (event) => {
    hotkeys.pause();
    hotkeys.startRecording();
    if (Helper.Validator.isDefined(onFocus) === true) {
      onFocus(event);
    }
  };

  const BlurHandler = (event) => {
    hotkeys.unpause();
    if (Helper.Validator.isDefined(onBlur) === true) {
      onBlur(event);
    }
  };

  return (
    <input
      readOnly={true}
      type="text"
      value={inputValue}
      className={classNames}
      onKeyDown={InputKeyDownHandler}
      onFocus={focusHandler}
      onBlur={BlurHandler}
    />
  );
}

HotkeyField.propTypes = propTypes;

export default HotkeyField;
